import React from "react";
import Card from "../../component/Card";
import TrendingSkills from "../../component/TrendingSkills";
import QuotesSlider from "../../component/QuotesSlider";
import Hero from "./Hero";
import {
  ShoppingBag,
  FileText,
  GraduationCap,
  BookOpen,
  Briefcase,
  Map,
  Users,
  Code,
  Sparkles,
} from "lucide-react";

function Home() {
  const features = [
    {
      title: "Gadget MarketPlace",
      icon: <ShoppingBag className="w-6 h-6 text-purple-600" />,
      link: "/marketplace",
      description: "Buy, sell & trade student laptops, phones, and accessories.",
    },
    {
      title: "Placement Kit",
      icon: <Code className="w-6 h-6 text-blue-600" />,
      link: "/showcoding",
      description: "Coding problems, interview prep & placement practice.",
    },
    {
      title: "Resume Builder",
      icon: <FileText className="w-6 h-6 text-emerald-600" />,
      link: "/resume",
      description: "Build ATS-friendly professional resumes in minutes.",
    },
    {
      title: "University Result",
      icon: <GraduationCap className="w-6 h-6 text-amber-600" />,
      link: "/result",
      description: "Check semester marksheets & result portal links.",
    },
    {
      title: "Notes & Papers",
      icon: <BookOpen className="w-6 h-6 text-indigo-600" />,
      link: "/notes",
      description: "Download handwritten notes and exam question papers.",
    },
    {
      title: "Internships & Jobs",
      icon: <Briefcase className="w-6 h-6 text-rose-600" />,
      link: "/jobs",
      description: "Off-campus placement drives and remote job openings.",
    },
    {
      title: "Learning Roadmaps",
      icon: <Map className="w-6 h-6 text-teal-600" />,
      link: "/roadmap",
      description: "Curated learning paths for Tech, Data, and Design.",
    },
    {
      title: "Campus Ambassadors",
      icon: <Users className="w-6 h-6 text-cyan-600" />,
      link: "/ambassadors",
      description: "Represent your college and lead student communities.",
    },
  ];

  return (
    <div className="bg-slate-50 min-h-screen">
      {/* Hero Section */}
      <Hero />

      {/* Services Grid Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <span className="inline-flex items-center space-x-1.5 px-3.5 py-1.5 rounded-full bg-purple-50 text-purple-700 text-xs font-bold border border-purple-100 mb-3">
            <Sparkles size={14} />
            <span>Campus Suite Services</span>
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 tracking-tight mb-3">
            Explore All Campus Tools
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto font-medium">
            Everything you need for your academic, career, and campus life — designed for modern students.
          </p>
        </div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              title={feature.title}
              icon={feature.icon}
              link={feature.link}
              description={feature.description}
            />
          ))}
        </div>
      </section>

      {/* Trending Skills Section */}
      <div className="py-8 bg-white border-y border-gray-100">
        <TrendingSkills />
      </div>

      {/* Quotes & Motivation Section */}
      <div className="py-12 bg-slate-50">
        <QuotesSlider />
      </div>
    </div>
  );
}

export default Home;
